// Basketball half-court zone polygons. SVG viewBox: 0 0 500 470
// Baseline is at top (y=50), half-court line at bottom (y=470). Basket at (250,50).

export const ZONES = [
  { id: "garrafao", name: "Garrafão", points: 2,
    poly: "180,50 320,50 320,240 180,240",
    label: { x: 250, y: 145 } },
  { id: "zm_esq_2", name: "Zona morta esq. 2pts", points: 2,
    poly: "40,50 180,50 180,210 40,210",
    label: { x: 110, y: 135 } },
  { id: "zm_dir_2", name: "Zona morta dir. 2pts", points: 2,
    poly: "320,50 460,50 460,210 320,210",
    label: { x: 390, y: 135 } },
  { id: "zm_esq_3", name: "Zona morta esq. 3pts", points: 3,
    poly: "0,50 40,50 40,210 0,210",
    label: { x: 20, y: 135 } },
  { id: "zm_dir_3", name: "Zona morta dir. 3pts", points: 3,
    poly: "460,50 500,50 500,210 460,210",
    label: { x: 480, y: 135 } },
  { id: "45_esq_2", name: "45° esq. 2pts", points: 2,
    poly: "40,210 180,210 180,310 40,310",
    label: { x: 110, y: 265 } },
  { id: "45_dir_2", name: "45° dir. 2pts", points: 2,
    poly: "320,210 460,210 460,310 320,310",
    label: { x: 390, y: 265 } },
  { id: "frontal_2", name: "Frontal 2pts", points: 2,
    poly: "180,240 320,240 320,310 180,310",
    label: { x: 250, y: 280 } },
  { id: "45_esq_3", name: "45° esq. 3pts", points: 3,
    poly: "0,210 40,210 40,310 180,310 180,470 0,470",
    label: { x: 80, y: 400 } },
  { id: "45_dir_3", name: "45° dir. 3pts", points: 3,
    poly: "460,210 500,210 500,470 320,470 320,310 460,310",
    label: { x: 420, y: 400 } },
  { id: "frontal_3", name: "Frontal 3pts", points: 3,
    poly: "180,310 320,310 320,470 180,470",
    label: { x: 250, y: 395 } },
];

export const ZONE_MAP = ZONES.reduce((acc, z) => { acc[z.id] = z; return acc; }, {});

export const SHOT_TYPES = [
  { id: "bandeja", label: "Bandeja" },
  { id: "media_distancia", label: "Média distância" },
  { id: "tres_pontos", label: "3 Pontos" },
  { id: "lance_livre", label: "Lance Livre" },
  { id: "flare", label: "Flare" },
  { id: "apos_drible", label: "Após Drible" },
  { id: "em_movimento", label: "Em Movimento" },
];

export const SHOT_TYPE_MAP = SHOT_TYPES.reduce((acc, t) => { acc[t.id] = t.label; return acc; }, {});

export function colorForPct(pct, attempts) {
  if (!attempts || attempts === 0) return "#27272A";
  if (pct >= 70) return "#22C55E";
  if (pct >= 55) return "#EAB308";
  if (pct >= 40) return "#F97316";
  return "#EF4444";
}
